export default __webpack_public_path__ + "static/media/Home.baee9e9e.png";